import { Input } from "@swa-ui/core";

import { withFormField } from "../withFormField";

/**
 * TextFormField provides support for a standard Input component to be used in a Form.
 */

export const TextFormField = withFormField(Input);
